// import dropdownClubskp from "./dropdownClubskp";

export default {
  to: ['control-index'],
  logoSrc: '/assets/img/black/logo-cmdctrl.svg',
  title: [
    { text: 'CMD', color: '#ec2027' },
    { text: 'CTRL', color: '' },
  ],
  links(group, siteId) {
    return [
      // {
      //   icon: "home",
      //   title: "Home",
      //   to: ["mytracker"],
      //   links: false
      // },
      {
        icon: 'user',
        title: 'Users',
        to: ['control-index'],
        links: false,
      },
      {
        icon: 'factory',
        title: 'Brands',
        to: ['control-brands'],
        links: false,
      },
      {
        icon: 'transporter',
        title: 'Distributors',
        to: ['control-distributors'],
        links: false,
      },
      {
        icon: 'gear',
        title: 'ETL Data',
        to: null,
        links: [
          // {
          //   iconClass: 'left-nav-icons left-nav-icons--scissors',
          //   title: 'Salons',
          //   to: ['control-salons'],
          //   links: false,
          // },
          // {
          //   iconClass: 'left-nav-icons left-nav-icons--user',
          //   title: 'Dist Reps',
          //   to: ['control-reps'],
          //   links: false,
          // },
          {
            iconClass: 'left-nav-icons left-nav-icons--expenses',
            title: 'Dist Sales',
            to: ['control-sales'],
            links: false,
          },
          {
            iconClass: 'left-nav-icons left-nav-icons--products',
            title: 'Dist Products',
            to: ['control-products'],
            links: false,
          },
          {
            iconClass: 'left-nav-icons left-nav-icons--products',
            title: 'Master Products',
            to: ['control-masterproducts'],
            links: false,
          },
          // {
          //   iconClass: 'left-nav-icons left-nav-icons--policies',
          //   title: "KPI's",
          //   to: ['control-kpis'],
          //   links: false,
          // },
        ],
      },
      {
        icon: 'list',
        title: 'Content',
        to: ['control-content'],
        links: false,
      },
      // {
      //   icon: 'folder',
      //   title: 'Filevault',
      //   to: ['control-filevault'],
      //   links: false,
      // },
      {
        icon: 'users',
        title: 'Groups',
        to: ['control-groups'],
        links: false,
      },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--policies',
      //   title: 'Policies',
      //   to: ['control-policies'],
      //   links: false,
      // },
      {
        icon: 'configurator',
        title: 'Configuration',
        to: ['control-config'],
        links: false,
      },
      // ...dropdownClubskp(group, siteId)
    ];
  },
};



// WEBPACK FOOTER //
// ./src/configs/sidebar/cmdctrl.js